import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import SearchComp from "./SearchComp";
import SimpleBadge from "./Badge";
import ImageAvatars from "./Avataar";
function HeaderProfile() {
  return (
    <Navbar bg="light" expand="lg" className="p-3">
      <div className="ml-5">
        <h5>RESTAURANT INFO</h5>
      </div>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto mr-5 ">
          <SearchComp />
          <SimpleBadge />
          <ImageAvatars />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
export default HeaderProfile;
